import type { ProgramInviteType } from 'models';
import { useState } from 'react';
import type { FormInstance } from 'ui';

import { useDebounce } from 'common/hooks';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useCommunitiesUsersInfiniteQuery } from 'features/communities/queries';
import type { EmailSelectedUser, RegisteredSelectedUser } from '../../../../types';
import type { InviteesType } from '../../../EventInvitees';
import type { CommonFormValues } from './hooks';
import InviteesPicker from './InviteesPicker';

type P = {
  allowedInvites?: InviteesType[];
  communityId: string;
  form: FormInstance<CommonFormValues>;
  inviteType: ProgramInviteType;
  onBack?: () => void;
  onInvite: (
    inviteType: ProgramInviteType,
    invitees: RegisteredSelectedUser[],
    emailInvitees?: EmailSelectedUser[],
  ) => void;
  // TODO this should be type
  role?: 'admin' | 'member';
};

const CommunitiesEventInviteesPicker = ({ communityId, role, ...rest }: P) => {
  const [search, setSearch] = useState<string>();
  const { isDebouncing, value } = useDebounce(search);
  const {
    data: communitiesUsers,
    error: communitiesUsersError,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingCommunitiesUsers,
    isLoading: isLoadingCommunitiesUsers,
    isRefetching: isRefetchingCommunitiesUsers,
  } = useCommunitiesUsersInfiniteQuery({
    filter: { communitiesIds: [communityId], role, search: value },
    pagination: { pageSize: 6 },
  });

  const allCommunitiesUsers = communitiesUsers?.pages.flat();

  return (
    <InviteesPicker
      {...rest}
      data={allCommunitiesUsers}
      error={communitiesUsersError}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetching={isFetchingCommunitiesUsers}
      isLoading={isLoadingCommunitiesUsers || isDebouncing}
      isRefetching={isRefetchingCommunitiesUsers}
      onSearch={setSearch}
    />
  );
};

export default CommunitiesEventInviteesPicker;
